<template>
  <div id="app" class="flex flex-col min-h-screen">
    <!-- 头部导航 -->
    <AppHeader />
    
    <!-- 主内容区 -->
    <main class="flex-1">
      <router-view />
    </main>
    
    <!-- 尾部导航 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style>
/* 全局样式已在index.html中定义 */
</style>
